<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4483 14.0172H14.8966V8.49999C14.8966 8.20734 14.7803 7.92667 14.5734 7.71974C14.3664 7.5128 14.0858 7.39654 13.7931 7.39654H9.93103V2.98275C9.93103 2.6901 9.81478 2.40943 9.60784 2.2025C9.4009 1.99556 9.12024 1.8793 8.82759 1.8793H2.2069C1.91424 1.8793 1.63358 1.99556 1.42664 2.2025C1.2197 2.40943 1.10345 2.6901 1.10345 2.98275V14.0172H0.551724C0.405398 14.0172 0.265065 14.0754 0.161596 14.1788C0.0581279 14.2823 0 14.4226 0 14.569C0 14.7153 0.0581279 14.8556 0.161596 14.9591C0.265065 15.0626 0.405398 15.1207 0.551724 15.1207H15.4483C15.5946 15.1207 15.7349 15.0626 15.8384 14.9591C15.9419 14.8556 16 14.7153 16 14.569C16 14.4226 15.9419 14.2823 15.8384 14.1788C15.7349 14.0754 15.5946 14.0172 15.4483 14.0172ZM13.7931 8.49999V14.0172H9.93103V8.49999H13.7931ZM2.2069 2.98275H8.82759V14.0172H7.72414V10.7069C7.72414 10.5606 7.66601 10.4202 7.56254 10.3168C7.45907 10.2133 7.31874 10.1552 7.17241 10.1552H3.86207C3.71574 10.1552 3.57541 10.2133 3.47194 10.3168C3.36847 10.4202 3.31034 10.5606 3.31034 10.7069V14.0172H2.2069V2.98275ZM6.62069 14.0172H4.41379V11.2586H6.62069V14.0172ZM3.31034 6.2931C3.31034 6.14677 3.36847 6.00644 3.47194 5.90297C3.57541 5.7995 3.71574 5.74137 3.86207 5.74137H4.96552V4.63792C4.96552 4.4916 5.02365 4.35126 5.12711 4.2478C5.23058 4.14433 5.37091 4.0862 5.51724 4.0862C5.66357 4.0862 5.8039 4.14433 5.90737 4.2478C6.01084 4.35126 6.06897 4.4916 6.06897 4.63792V5.74137H7.17241C7.31874 5.74137 7.45907 5.7995 7.56254 5.90297C7.66601 6.00644 7.72414 6.14677 7.72414 6.2931C7.72414 6.43942 7.66601 6.57976 7.56254 6.68322C7.45907 6.78669 7.31874 6.84482 7.17241 6.84482H6.06897V7.94827C6.06897 8.09459 6.01084 8.23493 5.90737 8.3384C5.8039 8.44186 5.66357 8.49999 5.51724 8.49999C5.37091 8.49999 5.23058 8.44186 5.12711 8.3384C5.02365 8.23493 4.96552 8.09459 4.96552 7.94827V6.84482H3.86207C3.71574 6.84482 3.57541 6.78669 3.47194 6.68322C3.36847 6.57976 3.31034 6.43942 3.31034 6.2931Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#7F7F7F'
    },
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '17'
    }
  }
}
</script>
